/*
 * Copyright (c) 2020. American Express Company
 */

import { RuleMatcher } from 'src/types/ruleMatcher.enum';

export class RuleModel {
    id!: string;
    priority!: number;
    groupUid!: string;
    transactionName: string;
    matcher: RuleMatcher;
    planUid!: string;
}
